export default __webpack_public_path__ + "static/media/customer.92db707c.svg";